<template>
  <form class="form-bonus-system-settings" v-on:submit.prevent="onSubmit">
    <h2 v-if="title" class="form-bonus-system-settings__title">{{ title }}</h2>
    <p
      v-if="!allowEditOrganizationBonusSettings"
      class="form-bonus-system-settings__warning-caption"
    >
      Внесение изменений возможно только в основном филиале.
    </p>
    <input-lifetime-bonus-days
      title="Срок действия бонусов (дней): "
      v-bind:class="{ disabled: !allowEditOrganizationBonusSettings }"
      v-model="settings.organizationBonusSettings.lifetimeBonusDays"
      v-bind:disabled="!allowEditOrganizationBonusSettings"
      v-bind:violations="lifetimeBonusDaysErrors"
    />
    <div class="form-bonus-system-settings__group-field">
      <span v-bind:class="{ disabled: !allowEditOrganizationBonusSettings }">
        Процент начисления бонусами:
      </span>
      <input-discount-in-percent
        v-model="settings.organizationBonusSettings.accrualBonusPercent"
        class="form-bonus-system-settings__input"
        v-bind:disabled="!allowEditOrganizationBonusSettings"
        v-bind:violations="accrualBonusPercentErrors"
      />
    </div>
    <div class="form-bonus-system-settings__group-field">
      <input-checkbox
        title="Приветственный бонус"
        v-model="settings.organizationBonusSettings.welcomeBonusEnabled"
        v-bind:class="{ disabled: !allowEditOrganizationBonusSettings }"
        v-bind:disabled="!allowEditOrganizationBonusSettings"
        v-on:input="onChangeToggle($options.toggleWelcomeBonus)"
      />
      <bonus-input
        v-if="settings.organizationBonusSettings.welcomeBonusEnabled"
        v-model="settings.organizationBonusSettings.welcomeBonusAmount"
        v-bind:disabled="!allowEditOrganizationBonusSettings"
        v-bind:violations="welcomeBonusAmountErrors"
        v-bind:max="999999"
      />
    </div>
    <div class="form-bonus-system-settings__group-field">
      <input-checkbox
        title="Бонус в день рождения"
        v-bind:class="{ disabled: !allowEditOrganizationBonusSettings }"
        v-model="settings.organizationBonusSettings.birthdayBonusEnabled"
        v-bind:disabled="!allowEditOrganizationBonusSettings"
        v-on:input="onChangeToggle($options.toggleBirthdayBonus)"
      />
      <bonus-input
        v-if="settings.organizationBonusSettings.birthdayBonusEnabled"
        v-model="settings.organizationBonusSettings.birthdayBonusAmount"
        v-bind:disabled="!allowEditOrganizationBonusSettings"
        v-bind:violations="birthdayBonusAmountErrors"
        v-bind:max="999999"
      />
    </div>
    <div class="form-bonus-system-settings__group-field">
      <div class="form-bonus-system-settings__row">
        <input-checkbox
          v-model="settings.organizationBonusSettings.paymentLimitPercentEnable"
          title="Лимит оплаты бонусами, %"
          v-bind:class="{ disabled: !allowEditOrganizationBonusSettings }"
          v-bind:disabled="!allowEditOrganizationBonusSettings"
          v-on:input="onChangeToggle($options.toggleLimitPercent)"
        />
        <help-icon
          v-if="settings.organizationBonusSettings.paymentLimitPercentEnable"
          class="form-bonus-system-settings__help"
          v-bind:tooltip-text="'Укажите, какую часть чека можно оплатить бонусами'"
          v-bind:sizes="{ width: 22, height: 22 }"
        />
      </div>
      <input-discount-in-percent
        v-if="settings.organizationBonusSettings.paymentLimitPercentEnable"
        v-model="settings.organizationBonusSettings.paymentLimitPercent"
        class="form-bonus-system-settings__input"
        v-bind:disabled="!allowEditOrganizationBonusSettings"
        v-bind:violations="paymentPercentageErrors"
      />
    </div>
    <div class="form-bonus-system-settings__row">
      <input-checkbox
        title="Начислять при оплате бонусами"
        v-model="settings.organizationBonusSettings.accrueOnBonusPayment"
        v-bind:class="{ disabled: !allowEditOrganizationBonusSettings }"
        v-bind:disabled="!allowEditOrganizationBonusSettings"
      />
      <help-icon
        v-if="settings.organizationBonusSettings.accrueOnBonusPayment"
        class="form-bonus-system-settings__help"
        v-bind:tooltip-text="'Начислять бонусы при оплате со списанием бонусов'"
        v-bind:sizes="{ width: 22, height: 22 }"
      />
    </div>
    <div>
      <p>Бонусами нельзя оплатить услуги или категорию услуг
        <button
          class="form-bonus-system-settings__link"
          type="button"
          v-on:click="onOpenSelectRedemptionServiceModal">Добавить
        </button>
      </p>
      <span class="form-bonus-system-settings__text-secondary">
        Выбрано услуг:
        {{ settings.clinicBonusSettings.excludedRedemptionServiceIds.length }}
      </span>
    </div>
    <div>
      <p>Бонусы не начисляются на услуги или категорию услуг
        <button
          class="form-bonus-system-settings__link"
          type="button"
          v-on:click="onOpenSelectAccrualServiceModal">Добавить
        </button>
      </p>
      <span class="form-bonus-system-settings__text-secondary">
        Выбрано услуг:
        {{ settings.clinicBonusSettings.excludedAccrualServiceIds.length }}
      </span>
    </div>
    <div class="form-bonus-system-settings__buttons">
      <button
        class="form-bonus-system-settings__button-cancel"
        type="button"
        v-on:click="onClose">
        Отмена
      </button>
      <button
        class="form-bonus-system-settings__button-submit"
        type="submit"
        v-bind:disabled="!isChanged">
        Применить изменения
      </button>
    </div>
    <modal-dialog
      with-cross
      width="700px"
      max-width="80%"
      v-model="isShowSelectRedemptionServicesModal"
      title="Выберите услуги исключения для оплаты бонусами"
      class="form-bonus-system-settings__modal"
      v-on:input="closeSelectRedemptionServiceModal"
      v-on:on-click-outside="closeSelectRedemptionServiceModal"
    >
      <modal-prices-service-selector
        ref="modalPricesServiceSelector"
        v-bind:services="services"
        v-bind:prices="servicePriceList"
        v-model="settings.clinicBonusSettings.excludedRedemptionServiceIds"
        v-on:cancel="closeSelectRedemptionServiceModal"
        v-on:submit="onInputExecutedRedemptionService"
      />
    </modal-dialog>
    <modal-dialog
      v-model="isShowSelectAccrualServicesModal"
      class="form-bonus-system-settings__modal"
      width="700px"
      max-width="80%"
      title="Выберите услуги исключения для начисления бонусами"
      with-cross
      v-on:input="closeSelectAccrualServiceModal"
      v-on:on-click-outside="closeSelectAccrualServiceModal"
    >
      <modal-prices-service-selector
        ref="modalPricesServiceSelector"
        v-model="settings.clinicBonusSettings.excludedAccrualServiceIds"
        v-bind:prices="servicePriceList"
        v-bind:services="services"
        v-on:cancel="closeSelectAccrualServiceModal"
        v-on:submit="onInputExecutedAccrualService"
      />
    </modal-dialog>
  </form>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';
import {
  BonusSettings,
  TOGGLE_BIRTHDAY_BONUS,
  TOGGLE_LIMIT_PERCENT,
  TOGGLE_WELCOME_BONUS,
} from '@/mixins/loyaltySystemMixin';
import BonusInput from '@/components/BonusInput.vue';
import InputDiscountInPercent from '@/components/InputDiscountInPercent.vue';
import HelpIcon from '@/components/HelpIcon.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import ModalPricesServiceSelector from '@/components/ModalPricesServiceSelector.vue';
import InputLifetimeBonusDays from '@/components/InputLifetimeBonusDays.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.violations ? vm.violations[cause] : []
);

/**
 * @description Название события закрытия формы.
 * @type {string}
 */
const NAME_EVENT_CLOSE = 'close';

export default {
  /**
   * @description Компонент настройки бонусной системы
   */
  name: 'FormBonusSystemSettings',
  components: {
    ModalPricesServiceSelector,
    InputLifetimeBonusDays,
    ModalDialog,
    HelpIcon,
    InputDiscountInPercent,
    BonusInput,
    InputCheckbox,
  },
  toggleWelcomeBonus: TOGGLE_WELCOME_BONUS,
  toggleBirthdayBonus: TOGGLE_BIRTHDAY_BONUS,
  toggleLimitPercent: TOGGLE_LIMIT_PERCENT,
  computed: {
    /**
     * @description Имеет возможность редактировать настройки бонусной системы организации
     * @returns {Boolean}
     */
    allowEditOrganizationBonusSettings() {
      return this.settings.isMainBranch;
    },
    lifetimeBonusDaysErrors: resolveInputErrors('lifetime-bonus-days'),
    birthdayBonusAmountErrors: resolveInputErrors('birthday-bonus-amount'),
    welcomeBonusAmountErrors: resolveInputErrors('welcome-bonus-amount'),
    paymentPercentageErrors: resolveInputErrors('payment-limit-percentage'),
    accrualBonusPercentErrors: resolveInputErrors('accrual-bonus-percent'),
    /**
     * @description Есть ли изменения.
     * @returns {boolean}
     */
    isChanged() {
      return this.settings.isChanged();
    },
    /**
     * @description Настройки
     * @type {BonusSettings}
     */
    settings: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    /**
     * @description Открытие модального окна выбора услуг исключений для списания.
     * @returns {void}
     */
    onOpenSelectRedemptionServiceModal() {
      this.isShowSelectRedemptionServicesModal = true;
      this.savedExcludedRedemptionServiceIds = this
        .settings
        .clinicBonusSettings
        .excludedRedemptionServiceIds
        .map((item) => item);
    },
    /**
     * @description Открытие модального окна выбора услуг исключений для начисления.
     * @returns {void}
     */
    onOpenSelectAccrualServiceModal() {
      this.isShowSelectAccrualServicesModal = true;
      this.savedExcludedAccrualServiceIds = this
        .settings
        .clinicBonusSettings
        .excludedAccrualServiceIds
        .map((item) => item);
    },
    /**
     * @description Обработать ввод услуг исключений на оплату бонусами
     * @returns {void}
     */
    onInputExecutedRedemptionService(ids) {
      this.settings.excludedRedemptionServiceIds = ids;
      this.onInput();
      this.isShowSelectRedemptionServicesModal = false;
    },
    /**
     * @description Обработать ввод услуг исключений на начисление
     * @returns {void}
     */
    onInputExecutedAccrualService(ids) {
      this.settings.clinicBonusSettings.excludedAccrualServiceIds = ids;
      this.onInput();
      this.isShowSelectAccrualServicesModal = false;
    },
    /**
     * @description Закрыть модальное окно выбора услуг исключений для оплаты
     * @returns {void}
     */
    closeSelectRedemptionServiceModal() {
      this.isShowSelectRedemptionServicesModal = false;
      this
        .settings
        .clinicBonusSettings
        .excludedRedemptionServiceIds = this.savedExcludedRedemptionServiceIds;
    },
    /**
     * @description Закрыть модальное окно выбора услуг исключений для списания
     * @returns {void}
     */
    closeSelectAccrualServiceModal() {
      this.isShowSelectAccrualServicesModal = false;
      this
        .settings
        .clinicBonusSettings
        .excludedAccrualServiceIds = this.savedExcludedAccrualServiceIds;
    },
    /**
     * @description Обработать изменение включения/выключения настройки
     * @param field
     */
    onChangeToggle(field) {
      this.settings.organizationBonusSettings.handleToggle(field);
      this.onInput();
    },
    /**
     * @description Отправить форму
     * @returns {void}
     */
    onSubmit() {
      this.$emit('submit');
    },
    onInput() {
      this.$emit('input', this.settings);
    },
    /**
     * @description Обработать закрытие формы.
     * @returns {void}
     */
    onClose() {
      this.$emit(NAME_EVENT_CLOSE);
    },
  },
  props: {
    /**
     * @description Заголовок.
     * @type {String}
     */
    title: { default: () => '', type: String },
    /**
     * @description Значение
     * @type {DiscountSettings}
     */
    /**
     * @description Прайс-лист услуг.
     */
    servicePriceList: { type: Array, default: () => [] },
    /**
     * @description Услуги
     * @type {Array}
     */
    services: { type: Array, default: () => [] },
    /**
     * @description Значение
     * @type {BonusSettings}
     */
    value: { type: BonusSettings, required: true },
    /**
     * @description Нарушения
     * @type {Object|null}
     */
    violations: { type: Object, required: false, default: () => {} },
  },
  data() {
    return {
      /**
       * @description Показывать ли модальное окно выбора услуг исключений на списание.
       * @type {Boolean}
       */
      isShowSelectRedemptionServicesModal: false,
      /**
       * @description Показывать ли модальное окно выбора услуг исключений на начисление.
       * @type {Boolean}
       */
      isShowSelectAccrualServicesModal: false,
      /**
       * @description Показывать ли модальное окно выбора услуг.
       * @type {Boolean}
       */
      isShowSelectServicesModal: false,
      /**
       * @description  Сохранённые идентификаторы услуг исключений для списания.
       * @type {Array<number>}
       */
      savedExcludedRedemptionServiceIds: [],
      /**
       * @description  Сохранённые идентификаторы услуг исключений для начисления.
       * @type {Array<number>}
       */
      savedExcludedAccrualServiceIds: [],
    };
  },
};

</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.form-bonus-system-settings {
  display: grid;
  row-gap: 20px;
  padding-block: 20px;
  &__title {
    font-size: 16px;
  }
  &__warning-caption {
    color: var(--warning-color);
  }
  &__row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  &__group-field {
    min-height: 40px;
    ::v-deep .checkbox {
      display: flex;
    }
  }
  &__group-field,
  ::v-deep .input-lifetime-bonus-days__label {
    display: grid;
    grid-template-columns: minmax(180px, 275px) auto;
    align-items: center;
    gap: 5px;
  }
  &__help {
    display: flex;
    margin: 0;
  }
  &__input {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    max-width: 438px;
    width: 100%;
    margin: 20px 0 0 auto;
  }
  &__button-submit {
    @include buttons.btn-blue(100%, 3rem, 1rem);
  }
  &__button-cancel {
    @include buttons.btn-transparent(100%, 3rem, 1rem);
  }
  &__link {
    color: var(--action-color);
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  &__text-secondary {
    font-size: 14px;
    color: var(--unfocus-color);
  }
  p {
    display: block;
  }
}

.disabled {
  color: #666;

  ::v-deep .checkbox__input:checked + .checkbox__title::before {
    background-color: #666;
    border-color: #666;
  }
}

@media screen and (max-width: 550px) {
  .form-bonus-system-settings {
    &__group-field,
    ::v-deep .input-lifetime-bonus-days__label {
      grid-template-columns: 1fr 120px;
    }
  }
}

@media screen and (max-width: 480px) {
  .form-bonus-system-settings {
    &__buttons {
      grid-template-columns: 1fr;
    }
  }
}
</style>
